import type { DocumentData, DocumentReference } from 'firebase/firestore'
import { Timestamp } from 'firebase/firestore'
import { mapTimeFromFirebaseFormat, mapToSimpleDateFromFirebase } from '~/helpers/time'

export class DeliversLocationModel {
  company: DocumentReference | null
  date: Timestamp | string | null
  deliver: DocumentReference | null
  route: DocumentReference | null

  locations: {
    latitude: number
    longitude: number
    date: Timestamp | string | null
  }[]

  reference: DocumentReference | null

  constructor(data: Partial<DeliversLocationModel>, reference?: DocumentReference) {
    this.company = data.company || null
    this.date = data.date instanceof Timestamp ? mapToSimpleDateFromFirebase(data.date) : null
    this.deliver = data.deliver || null
    this.route = data.route || null
    this.locations = data.locations?.map((location) => {
      return {
        latitude: location.latitude,
        longitude: location.longitude,
        date: location.date instanceof Timestamp ? mapTimeFromFirebaseFormat(location.date) : null,
      }
    }) || []

    this.reference = reference || null
  }

  toMap() {
    return {
      company: this.company,
      date: this.date,
      deliver: this.deliver,
      route: this.route,
      locations: this.locations,
      reference: this.reference,
    }
  }
}

export function mapDeliversLocation(data: DocumentData, reference?: DocumentReference) {
  return new DeliversLocationModel(data.data(), reference)
}
